var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showBackground)?_c('v-img',{staticClass:"background d-none d-sm-flex",attrs:{"contain":"","alt":"background","position":"left center","src":require("@/assets/image-lateral.png")}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }